import {FC} from 'external/react';

const closeButtonStyles: React.CSSProperties = {
  background: '#f1f5f9', border: 'none', borderRadius: '50%',
  width: 32, height: 32, cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  color: '#64748b', fontSize: 16, flexShrink: 0,
  transition: 'background 150ms',
};

const CloseButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <button
    onClick={onClick}
    style={closeButtonStyles}
    onMouseEnter={e => (e.currentTarget.style.background = '#e2e8f0')}
    onMouseLeave={e => (e.currentTarget.style.background = '#f1f5f9')}
  >
    ✕
  </button>
);

export default CloseButton;